/* pawty-nb-welcome-popup.js
   Shows the <pawty-welcome-popup> element once per browser session
   (sessionStorage -- cleared when the tab/browser session ends, so it
   reappears on the visitor's next actual visit but not on every page
   they click to within the same visit).

   The video plays with no player controls. It does NOT auto-close and
   does NOT loop -- once it reaches `ended` it just holds on its last
   frame (default <video> behavior with no extra work needed). The ONLY
   way to dismiss the popup is the visitor clicking the X themselves --
   no overlay-click, no Escape key -- and that X stays inert/hidden for
   a flat 15 seconds after the popup opens, independent of how long the
   video itself runs. If they still haven't clicked it a few seconds
   after it becomes available, it gently vibrates to draw the eye (same
   animation/timing as the header cart icon's attention pulse). */
(function () {
  var STORAGE_KEY = 'pawtyWelcomePopupSeen';
  var CLOSE_UNLOCK_MS = 6000; /* was 15000, then 7500, then 8000 -- popup felt too long before it could be closed */
  var VIBRATE_HINT_MS = 3000;
  var popup = document.getElementById('PawtyWelcomePopup');
  if (!popup) return;

  var alreadySeen;
  try {
    alreadySeen = window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    // Storage unavailable (private mode, disabled cookies, etc.) -- fail
    // open by treating every load as "already seen" so we never risk
    // showing it on every single page load for those visitors.
    alreadySeen = true;
  }
  if (alreadySeen) return;

  var video = popup.querySelector('.pawty-welcome-popup__video');
  var closeBtn = popup.querySelector('.pawty-welcome-popup__close');
  var canClose = false;

  function markSeen() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* no-op */
    }
  }

  function announceEnded() {
    // Lets other page elements (e.g. the floating "Free Paw-ime toy"
    // callout on the home page) key their own timing off of the video
    // actually finishing, independent of the close-button unlock timer.
    document.dispatchEvent(new CustomEvent('pawty:welcome-video-ended'));
  }

  function close() {
    if (!canClose) return;
    popup.setAttribute('hidden', '');
    document.body.classList.remove('pawty-welcome-popup-open');
    if (video) video.pause();
    // The floating "Free Paw-ime toy" callout on the home page waits on
    // THIS specifically (not the video ending) -- if the visitor never
    // clicks the X, that animation should never fire at all.
    document.dispatchEvent(new CustomEvent('pawty:welcome-popup-closed'));
  }

  function unlockClose() {
    canClose = true;
    if (!closeBtn) return;
    closeBtn.hidden = false;
    window.setTimeout(function () {
      // Still open? Give the X a gentle vibrate to draw attention --
      // it keeps looping on its own (see CSS) until clicked.
      if (!popup.hasAttribute('hidden')) {
        closeBtn.classList.add('pawty-nb-vibrate-hint');
      }
    }, VIBRATE_HINT_MS);
  }

  function open() {
    markSeen();
    popup.removeAttribute('hidden');
    document.body.classList.add('pawty-welcome-popup-open');
    if (video) {
      video.play().catch(function () {
        /* Autoplay blocked -- the video will just sit on its poster
           frame; the 15s close-unlock timer below still applies. */
      });
    }
    window.setTimeout(unlockClose, CLOSE_UNLOCK_MS);
  }

  if (video) {
    video.addEventListener('ended', announceEnded);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  // Small delay so it doesn't compete with the very first paint.
  window.setTimeout(open, 600);
})();
